import * as types from "./types";

const mutations = {
    [types.LOADING_CHARTOFACCOUNT](state, value) {
        state.loading = value;
    },
    [types.GET_CHARTOFACCOUNT_LIST](state, chartofaccount) {
        state.chartofaccount = chartofaccount;
    },
    [types.GET_CHARTOFACCOUNT_ID](state, id) {
        state.id = id;
    },
    [types.REMOVE_CHARTOFACCOUNT](state, id) {        
        state.chartofaccount = state.chartofaccount.filter((x) => x.id !== id);        
    },
    [types.ADD_CHARTOFACCOUNT](state, chartofaccount) {        
        state.chartofaccount.unshift(chartofaccount);
    },
    [types.UPDATE_CHARTOFACCOUNT](state, chartofaccount) {        
        const chartofaccountIndex = state.chartofaccount.findIndex((x) => x.id === chartofaccount.id);
        state.chartofaccount[chartofaccountIndex] = chartofaccount;        
    }
};

export default mutations;